import React, { useState, useEffect, useRef, useCallback, useReducer, useMemo } from "react";
// import { useDispatch, useMappedState } from "redux-react-hook";
import { Map, Set } from "immutable";
import styled from "styled-components";
import GroupChatAPI from "../../../api/GroupChatAPI";
// import {FACELESS_AVATAR} from "../../../constants/config";

import FACELESS_AVATAR from "../../../assets/images/no_face.png";

import moment from "moment";

import toast from "react-hot-toast";

import { Button } from "../../ui-kit/styled-templates";

import plane_img from "../../../assets/images/paper-plane.png";
import ajax_loader_img from "../../../assets/images/ajax-loader.gif";
import ReactHelper from "../../../helpers/ReactHelper";
import UserNameSpan from "./UserNameSpan";

import attach_img from "./attach.png";
import no_messages_image from "./no_messages.svg";
import cross_img from "./cross_remove.png";
import Sidebar from "arui-feather/sidebar";
import { PhotoDropzone } from "../../ui-kit/styled-templates";
import { Control } from "../../ui-kit/control";
import { ERequestStatus } from "../../../types/enums";
import ls from "local-storage";
import { useTranslation } from "react-i18next";

export function renderMessage(message) {
    if (message == undefined) {
        return "";
    }
    return <span dangerouslySetInnerHTML={{ __html: message }}></span>;
}

export default function RoomChatPanel(props) {
    const {
        roomId,
        canEditMessages = true,
        messageColor = "black",
        // canWrite = true,
        status,
        onMessageSent = () => {

        }
    } = props;
    let isAdminMode = (ls("admin_mode") == "yes");

    const { t, i18n } = useTranslation();
    let isRu = i18n.language === "ru";

    const messageInput = useRef();
    const [loading, setLoading] = useState(false);
    const [sending, setSending] = useState(false);
    const [messages, setMessages] = useState([]);
    const [selectedMessageId, setSelectedMessageId] = useState(undefined);
    const [loadingMessageId, setLoadingMessageId] = useState(undefined);

    const [fileModalOpen, setFileModalOpen] = useState(false);

    const [attachedFileUrl, setAttachedFileUrl] = useState();
    console.log("RoomChatPanel: status = ", status);

    const [chatInfo, setChatInfo] = useState(undefined);

    // let canWrite = ([])
    let canWrite = true;
    if ([ERequestStatus.New, ERequestStatus.Approved, ERequestStatus.Review].indexOf(status) == -1) {
        canWrite = false;
    }

    let userId = window?.currentUser?.id;
    let usersMap = Map();
    let chatActive = (chatInfo?.chatActive == undefined ? true : chatInfo?.chatActive);

    // const { userId, usersMap } = useMappedState(useCallback(state => {
    //     return {
    //         userId: state.users.currentUserId,
    //         usersMap: state.users.usersMap
    //     };
    // }));

    useEffect(() => {
        setLoading(true);
        GroupChatAPI.getGroupMessages(roomId, 0).then(arr => {
            setMessages(arr);
            console.log("got group messages: arr = ", arr);
            GroupChatAPI.getGroupInfo(roomId).then(info => {
                console.log("--->>> infor = ", info);
                setChatInfo(info);
                setLoading(false);
                GroupChatAPI.readAllMessages(roomId).then(() => {
                    console.log("all messages are read");
                });
            });
        });
    }, [roomId]);

    let committee = chatInfo?.dorm?.details?.rules?.committee;
    let uniName = chatInfo?.uni?.details?.name;

    const batches = useMemo(() => {
        let batches = [];
        let xMessages = messages.map(xx => ({
            ...xx,
            isMine: (xx.userId == userId)
        })).filter(xx => (xx?.message != undefined && xx?.message.trim() != ""));
        if (xMessages.length == 0) {
            return [];
        }
        batches.push({
            messages: [xMessages[0]],
            isMine: xMessages[0].isMine,
            id: xMessages[0].id
        });
        console.log("xMessages = ", xMessages);
        for (let i = 1; i < xMessages.length; i++) {
            if (batches[batches.length - 1].userId == xMessages[i].userId) {
                batches[batches.length - 1].messages.push(xMessages[i]);
            } else {
                batches.push({
                    messages: [xMessages[i]],
                    isMine: xMessages[i].isMine,
                    id: xMessages[i].id
                });
            }
        }
        return batches;
    }, [roomId, messages]);

    ReactHelper.useInterval(() => {
        let now = +new Date();
        if (loadingMessageId != undefined) {
            return;
        }
        GroupChatAPI.getGroupMessages(roomId, +new Date() - 5 * 60 * 1000).then(arr => {
            if (loadingMessageId != undefined) {
                return;
            }
            if (arr.length > 0) {
                let mSt = arr.reduce((st, m) => st.add(m.id), Set());
                let newMessages = messages.filter(x => !(mSt.has(x.id))).concat(arr);
                setMessages(newMessages);
                setTimeout(() => {
                    try {
                        let objDiv = document.getElementById("batches_list");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    } catch (e) {

                    }
                }, 100);
            }
        });
    }, 5000);

    console.log("render: -> messages = ", messages);
    console.log("render: -> chat info = ", chatInfo);
    let noMessages = (messages.length == 0);

    if (messages.length == 0 && loading == true) {
        return (
            <div className={"p-2"}>
                загрузка...
            </div>
        );
    }

    return (
        <Wrapper>

            <h2 style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 5,
                height: headingHeight,
                color: "black"
            }}>
                            <span>
                                Чат
                            </span>
                {(isAdminMode == false || chatActive == false) ? null :
                    <Button onClick={async () => {
                        if (window.confirm("Вы уверены?") == false) {
                            return;
                        }
                        await GroupChatAPI.toggleChatGroupActivity(roomId, !chatActive);
                        let grInfo = await GroupChatAPI.getGroupInfo(roomId);
                        setChatInfo(grInfo);
                        toast.success("Чат завершен");
                    }}>
                        {isRu ? "Завершить" : "Finish"}
                    </Button>
                }
            </h2>

            {committee == undefined ? null :
                <div style={{ fontSize: "12px", height: infoHeight, color: "black" }}>

                    <b>{uniName}</b>
                    <br />

                    {committee?.name}
                    <br />

                    {`${committee?.phone} , ${committee?.email}`}
                </div>
            }

            <BatchesList id={"batches_list"}>

                {noMessages == false ? null :
                    <NoMessagesPlaceholder>
                        <NoMessagesImagePlaceholder>
                            <NoMessagesImage src={no_messages_image} />
                        </NoMessagesImagePlaceholder>
                        <NoMessagesText>
                            В этом чате еще никто не писал.
                            Будьте первым, кто отправит сообщение!
                        </NoMessagesText>
                    </NoMessagesPlaceholder>
                }

                {batches.map((batch, k) => {
                    let { id, messages, isMine } = batch;
                    // let ava = (isMine == true) ? myAvatar : friendAvatar;
                    const ava = FACELESS_AVATAR;
                    let userId = messages[0].userId;
                    return (
                        <BatchItem key={id} isMine={isMine}>

                            <UserPlaceholder isMine={isMine} style={{ backgroundImage: `url(${ava})` }}>

                            </UserPlaceholder>
                            <UserNameSpan userId={userId} />

                            <MessagesPlaceholder>
                                <MessagesList>
                                    {messages.map((m, j) => {
                                        let isLoading = (m?.id == loadingMessageId && loadingMessageId != undefined);
                                        let selected = (m.id == selectedMessageId);
                                        if ((m.message == undefined || m.message == "")) {
                                            return null;
                                        }
                                        return (
                                            <MessageItem key={m.id}>
                                                <Text color={messageColor}>
                                                    {userId == undefined ?
                                                        <span>
                                                                {renderMessage(m.message)} {" "}
                                                            </span>
                                                        :
                                                        <span>
                                                            {renderMessage(m.message)}
                                                            {" "}
                                                        </span>
                                                    }
                                                    {isLoading == false ? null :
                                                        <span>...</span>
                                                    }

                                                    {isAdminMode == false ? null :
                                                        <span style={{ cursor: "pointer", marginLeft: 5 }}>
                                            <AttachFileIcon src={cross_img} style={{ height: "12px" }}
                                                            onClick={async () => {
                                                                if (window.confirm("Вы уверены?") == false) {
                                                                    return;
                                                                }
                                                                await GroupChatAPI.deleteMessage(m.id);
                                                                let arr = await GroupChatAPI.getGroupMessages(roomId, 0);
                                                                // let newMessages = messages.filter(x => (x.id != m.id));

                                                                setMessages(arr);
                                                            }} />
                                        </span>
                                                    }

                                                </Text>

                                                {m.fileUrl == undefined ? null :
                                                    <div>
                                                        <a href={m.fileUrl} target={"_blank"}
                                                           style={{ color: "black", textDecoration: "underline" }}>
                                                            файл
                                                        </a>
                                                    </div>
                                                }

                                            </MessageItem>
                                        );
                                    })}
                                </MessagesList>
                            </MessagesPlaceholder>

                        </BatchItem>
                    )
                        ;
                })}
            </BatchesList>

            {
                ((canWrite == false) || (chatActive == false)) ?
                    <div style={{ color: "black", padding: "5px", fontSize: "12px" }}>
                        {"В данном чате нет возможности отправлять сообщения"}
                        {chatActive == true ? null : <span><br /> (чат завершен администратором)</span>}
                    </div>
                    :
                    <>
                        <InputPlaceholder>
                            <TextareaPlaceholder>
                                <Textarea ref={messageInput} placeholder="Ваше сообщение..."></Textarea>
                                <FileAreaPlaceholder>
                                    <AttachFileIcon src={attach_img} onClick={() => {
                                        setFileModalOpen(true);
                                    }} />

                                    {attachedFileUrl == undefined ? null :
                                        <span>
                                        <span>
                                            файл
                                        </span>
                                        <span style={{ cursor: "pointer", marginLeft: 5 }}>
                                            <AttachFileIcon src={cross_img} style={{ height: "12px" }} onClick={() => {
                                                setAttachedFileUrl(undefined);
                                            }} />
                                        </span>
                                    </span>
                                    }

                                </FileAreaPlaceholder>
                            </TextareaPlaceholder>
                            <ButtonPlaceholder>
                                <SendButton onClick={async () => {
                                    let text = messageInput.current.value;
                                    if (((text == undefined || text.trim() == "") && (attachedFileUrl == undefined)) || sending == true) {
                                        return;
                                    }
                                    // this.sendMessage();
                                    setSending(true);
                                    await GroupChatAPI.sendMessageToGroup(roomId, userId, (text == undefined || text == "-") ? "" : text, attachedFileUrl);
                                    await delay(1000);
                                    // let arr = await GroupChatAPI.getGroupMessages(roomId, +new Date() - 5 * 60 * 1000);
                                    let arr = await GroupChatAPI.getGroupMessages(roomId, 0);
                                    onMessageSent();
                                    if (arr.length > 0) {
                                        let mSt = arr.reduce((st, m) => st.add(m.id), Set());
                                        let newMessages = messages.filter(x => !(mSt.has(x.id))).concat(arr);
                                        setMessages(newMessages);
                                        setTimeout(() => {
                                            try {
                                                let objDiv = document.getElementById("batches_list");
                                                objDiv.scrollTop = objDiv.scrollHeight;
                                            } catch (e) {

                                            }
                                        }, 100);
                                    }
                                    messageInput.current.value = "";
                                    setSending(false);
                                    setAttachedFileUrl(undefined);
                                }}>
                                    <SendImage
                                        src={(sending == false) ? plane_img : ajax_loader_img} />
                                </SendButton>

                            </ButtonPlaceholder>

                        </InputPlaceholder>
                    </>
            }

            <Sidebar visible={fileModalOpen}
                     onCloserClick={() => {
                         setFileModalOpen(false);
                     }}>

                {fileModalOpen == false ? null :
                    <div>
                        <Control.File name="avatar" accept="image/jpeg, image/png, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
text/plain, application/pdf, image/*" className={"avatar_placeholder"}
                                      onChange={evt => {
                                          setAttachedFileUrl(evt.target.value);
                                          setFileModalOpen(false);
                                      }}
                        >
                            {attachedFileUrl == undefined ? <PhotoDropzone label={"Загрузить файл"} /> :
                                <div>
                                    <a href={attachedFileUrl} target={"_blank"}>
                                        Файл прикреплен
                                    </a>
                                </div>
                            }

                            {attachedFileUrl == undefined ? null :
                                <div style={{ marginTop: 10 }}>
                            <span style={{ cursor: "pointer", color: "red" }} onClick={() => {
                                setAttachedFileUrl(undefined);
                            }}>
                                загрузить другой файл
                            </span>
                                </div>
                            }


                        </Control.File>
                    </div>
                }

            </Sidebar>

        </Wrapper>
    );
}

function delay(time) {
    return new Promise(function (resolve) {
        setTimeout(resolve, time)
    });
}

function downloadFile(filename, text) {
    let element = document.createElement("a");
    element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

const TxtExportSpan = styled.span`
  opacity: 0.8;
  cursor: pointer;
  color: black;

  :hover {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  color: white;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-top: 0px;
`;

const headingHeight = 80;
const infoHeight = 80;
const inputBlockHeight = 80;
const userInfoWidth = 30;
const exportHeight = 0;

const BatchesList = styled.div`
  width: 100%;
  height: calc(100% - ${
          inputBlockHeight + exportHeight + infoHeight + headingHeight
  }px);
  max-height: calc(100% - ${
          inputBlockHeight + exportHeight + infoHeight + headingHeight
  }px);
  overflow-y: auto;
  padding-left: 3px;
  padding-right: 3px;
  box-sizing: border-box;
  border: 1px solid lightgrey;
  padding-top: 2px;
`;

const BatchItem = styled.div`
  text-align: ${
          props => (props.isMine == true ? "left" : "left")
  };
  display: block;
  margin-bottom: ${userInfoWidth}px;
`;

const UserPlaceholder = styled.div`
  display: inline-block;
  vertical-align: top;
  width: ${userInfoWidth}px;
  height: ${userInfoWidth}px;
  line-height: ${userInfoWidth}px;
  text-align: center;
  border-radius: 1000px;
  background-color: ${props => (props.isMine == true ? "blue" : "red")};
  box-sizing: border-box;
  color: white;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  float: ${props => (props.isMine == true ? "left" : "left")}
`;

const MessagesPlaceholder = styled.div`
  display: inline-block;
  vertical-align: top;
  width: calc(100% - ${userInfoWidth}px);
  box-sizing: border-box;
  padding: 5px;
  padding-top: 0px;
`;

const MessagesList = styled.div`

`;

const MessageItem = styled.div`
  margin-top: 5px;
  border-top: 1px dotted rgba(255, 255, 255, 0.1);
  padding-top: 5px;

  :first-of-type {
    margin-top: 0px;
    border-top: none;
    padding-top: 0px;
  }
`;

const Text = styled.div`
  color: ${props => (props.color == undefined ? "white" : props.color)};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;


  &:hover .sabir_chat_pencil_span {
    display: inline - block !important;
  }

  .pencil_placeholder {
    display: none;
  }

  :hover {
    .pencil_placeholder {
      display: inline - block;
    }

  }

`;

const PencilPlaceholder = styled.span`
  display: none;
  margin-left: 5px;
  opacity: 0.7;
  cursor: pointer;
  font-size: 12px;

  :hover {
    opacity: 1;
  }
`;

const InputPlaceholder = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.7);
  width: 100%;
  height: ${
          inputBlockHeight
  }px;
  box-sizing: border-box;
`;

const buttonWidth = 60;

const TextareaPlaceholder = styled.div`
  width: calc(100% - ${buttonWidth}px);
  vertical-align: top;
  display: inline-block;
  box-sizing: border-box;
  height: 100%;
  position: relative;
`;

const FileAreaPlaceholder = styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  left: 0px;
  z-index: 12;
`;

const AttachFileIcon = styled.img`
  height: 20px;
  cursor: pointer;
  display: inline-block;
  margin-right: 8px;
`;

const ButtonPlaceholder = styled.div`
  width: ${buttonWidth}px;
  vertical-align: top;
  display: inline-block;
  box-sizing: border-box;
  height: 100%;
  background-color: #314E66;
  color: white;
  line-height: ${inputBlockHeight}px;
  text-align: center;
`;

const SendButton = styled.button`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  line-height: ${inputBlockHeight}px;
  opacity: ${props => (props.disabled == true ? 0.5 : 1)};
  cursor: pointer;
  text-align: center;
  background-color: #314E66;
  outline: none;
  border: none;
  opacity: 0.9;

  :hover {
    opacity: 1;
  }
`;

const SendImage = styled.img`
  height: 40px;
  display: inline-block;
  vertical-align: middle;
`;

const Textarea = styled.textarea`
  border: none;
  height: 100%;
  min-height: 100%;
  width: 100%;
  outline: none;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 18px;
  padding-left: 5px;

  background-color: rgba(0, 0, 0, 0.4);

  ::placeholder {
    color: rgba(255, 255, 255, 0.7);
  }
`;

const NoMessagesPlaceholder = styled.div`
  text-align: center;
  opacity: 0.75;
  margin-top: 20px;
`;

const NoMessagesImagePlaceholder = styled.div`
  margin-bottom: 10px;
`;

const NoMessagesImage = styled.img`
  display: inline-block;
  //width: 90px;
`;

const NoMessagesText = styled.div`
  color: white;
  padding: 10px;
  font-size: 14px;
  color: black;
`;